import { DeepfakeJobTypeEnum } from '@models/enums/deepfake';

export const DeepfakeJobTypeUrlMapper = {
    [DeepfakeJobTypeEnum.IMAGE]: 'image',
    [DeepfakeJobTypeEnum.VIDEO]: 'video',
    [DeepfakeJobTypeEnum.AUDIO]: 'audio',
    [DeepfakeJobTypeEnum.DOCUMENT_IMAGE]: 'document/image',
} as const;

export type DeepfakeJobTypeUrl =
    (typeof DeepfakeJobTypeUrlMapper)[keyof typeof DeepfakeJobTypeUrlMapper];
